import { alpha, Box, Grid, Stack, Typography } from '@mui/material';
import { ReactElement, ReactNode } from 'react';
import { theme } from 'common/constants/theme';
import { ReactComponent as Image } from '../../common/svg/1.svg';

const styles = {
  leftPanel: {
    display: { xs: 'none', md: 'block' },
    background:
      'linear-gradient(to right, #5B00D7 0%, #7E45E2 25%, #9C6FF0 50%, #B898F6 65%, #D0B5FD 80%, #FFFFFF 100%)',
    position: 'relative',
    overflow: 'hidden',
  },
  contentStack: {
    justifyContent: 'center',
    height: '100%',
    px: 4,
    position: 'relative',
    zIndex: 1,
    maxWidth: 570,
    margin: '0 auto',
  },
  blurTop: {
    position: 'absolute',
    top: -60,
    left: -60,
    width: 180,
    height: 180,
    bgcolor: alpha(theme.palette.background.paper, 0.12),
    filter: 'blur(48px)',
    borderRadius: '50%',
    zIndex: 0,
  },
  blurBottom: {
    position: 'absolute',
    bottom: -60,
    right: -60,
    width: 180,
    height: 180,
    bgcolor: alpha(theme.palette.background.paper, 0.1),
    filter: 'blur(48px)',
    borderRadius: '50%',
    zIndex: 0,
  },
  title: {
    fontWeight: 800,
    lineHeight: 1.15,
    letterSpacing: '-2px',
    mb: 2,
  },
  subtitle: {
    fontSize: 24,
    lineHeight: 1.35,
    mb: 2,
  },
};

interface Props {
  children: ReactNode;
}

export function Layout({ children }: Props): ReactElement {
  return (
    <Grid container component="main" sx={{ height: '100vh' }}>
      <Grid item xs={false} sm={false} md={7} sx={styles.leftPanel}>
        <Stack sx={styles.contentStack}>
          <Box sx={styles.blurTop} />
          <Box sx={styles.blurBottom} />
          <Typography variant="h3" color="primary.contrastText" sx={styles.title}>
            Launch Your Next Powerful Revenue Engine
          </Typography>
          <Typography color="primary.contrastText" sx={styles.subtitle}>
            Drive growth with innovative, results-driven opportunities designed for publishers, creators, and ambitious
            partners.
          </Typography>
          <Image />
        </Stack>
      </Grid>
      <Grid
        sx={{ position: 'relative' }}
        display="flex"
        alignItems="center"
        justifyContent="center"
        item
        xs={12}
        sm={12}
        md={5}
        component={Box}
      >
        {children}
      </Grid>
    </Grid>
  );
}
